import React, { Component } from 'react'
import {connect} from "react-redux"
import {buildHeaderArr} from "../Table/Utils";
import {
  addRemovedAttribute,
  removeRemovedAttribute,
} from "../../store/actions";

class ManageAttributes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      attributesVisible: false,
    };
  }

  toggleAttributes = () => {
    this.setState(state => ({ attributesVisible: !state.attributesVisible }));
  }

  handleChange = event => {
    const target = event.target;
    const id = target.name;
    if (target.checked) {
      this.props.removeRemovedAttribute(id);
    }
    else {
      this.props.addRemovedAttribute(id);
    }
  };

  handleAllChange = event => {
    let checked = event.target.checked;
    this.props.attributesAvailable.forEach(element => {
      if (checked) {
        this.props.removeRemovedAttribute(element.key);
      }
      else {
        this.props.addRemovedAttribute(element.key);
      }
    })
  };

  closeAttributes = event => {
    this.setState({ attributesVisible: false });
  }

  checkedTotalAttributes = () => {
    return this.props.attributesAvailable.reduce((accumulator, data) => {
      accumulator.checkedAttributes += data.checked ? 1 : 0;
      accumulator.totalAttributes += 1;
      return accumulator;
    }, {checkedAttributes: 0, totalAttributes: 0});
  }

  render() {
    const {attributesVisible} = this.state;
    const { searchExecuted, attributesAvailable } = this.props;
    const {checkedAttributes, totalAttributes} = this.checkedTotalAttributes();
    const all_checked = checkedAttributes === totalAttributes;

    return (
      searchExecuted &&  (<>
        {attributesVisible && searchExecuted &&
        <div className="manage-attributes">
          <div className="manage-attributes__inner">
            <form className="manage-attributes-form">
              <div className="form--inline">
                <h4 className="form__title">{this.props.strings['STRING:MANAGE_ATTRIBUTES']}{checkedAttributes ? " (" + checkedAttributes + "/" + totalAttributes + ")" : " (0/" + totalAttributes + ")"}</h4>
                <div className="attributeCheckbox">
                  <input type="checkbox" className="checkbox" id="checkbox-all" checked={all_checked} onChange={this.handleAllChange} />
                  <label htmlFor="checkbox-all">{this.props.strings['STRING:ALL_ATTRIBUTES']}</label>
                </div>
                {attributesAvailable.map(item => {
                  return item && Object.prototype.hasOwnProperty.call(item, 'key') && (
                    <div key={item.key} className="attributeCheckbox">
                      <input type="checkbox" className="checkbox" id={"checkbox-" + item.key} name={item.key} checked={item.checked} onChange={this.handleChange} />
                      <label htmlFor={"checkbox-" + item.key}>{item.title}</label>
                    </div>
                  );
                })}
              </div>
            </form>
            <button type="button" aria-label="Close" className="icon-close" data-close="" onClick={this.closeAttributes} >
              <span className="icon"></span>
              <span className="icon"></span>
            </button>
          </div>
        </div>
        }
        <div className={"product-finder-toggler toggle-attributes" + (attributesVisible ? " visible" : "")} onClick={this.toggleAttributes}>
          <span className="icon-filters"></span>
          {this.props.strings['STRING:MANAGE_ATTRIBUTES']}
        </div>
      </>)
    );
  }
}

const getAttributes = (header, removedAttributeFilters) => {
  return header.map((attribute) => {
      return {
        key: attribute[0],
        checked: !Object.prototype.hasOwnProperty.call(removedAttributeFilters, attribute[0]),
        title: attribute[1]
      }
    });
};

const mapStateToProps = (state) => {
  const removedAttributeFilters = state.parameters.removedAttributeFilters;
  return {
    searchExecuted: state.results.searchExecuted,
    attributesAvailable: getAttributes(buildHeaderArr(state.results.attributes, {}, state.results.result), removedAttributeFilters),
    removedAttributeFilters,
  }
};

export default connect(
  mapStateToProps,
  {addRemovedAttribute, removeRemovedAttribute}
)(ManageAttributes)
